import axios from "axios";

const {
	REACT_APP_URI_SUPPLIERS: URI_SUPPLIER,
	REACT_APP_URI_SERVER_DATE: URI_SERVER_DATE,
	REACT_APP_URI_CLIENT: URI_CLIENT,
	REACT_APP_URI_USERS_FILTER_BY_DATA_ID: URI_USERS_BY_DATA_ID,
	REACT_APP_URI_SUPPLIER_CLIENT_STATUS: URI_SUPPLIER_CLIENT_STATUS,
} = process.env

export const fetchServerDate = async () => {
	const { data } = await axios.get(URI_SERVER_DATE)
	return data
}

export const fetchSupplierById = async (dataID) => {
	const { data } = await axios.get(URI_SUPPLIER + dataID)
	return data
}

export const fetchAllClients = async () => {
	const { data } = await axios.get(URI_CLIENT)
	return data
}

export const fetchSupplierUsers = async (dataID) => {
	const { data } = await axios.post(URI_USERS_BY_DATA_ID, { idsToFind: [dataID] })
	return data
}

export const saveSupplierChanges = async ({ supplier, dataID }) => {
	const date = new Date()
	const year = date.getFullYear()
	const month = date.getMonth() + 1
	const day = date.getDate()

	const formData = new FormData();
	const supplierToSave = supplier

	formData.append("rfc", supplierToSave.informationCompliance.generalInformation.rfc)
	let saveWithFile = false
	const filesToSave = []

	if (supplierToSave.informationCompliance.generalInformation.curriculum.document?.name) {
		saveWithFile = true
		const fileToSave = supplierToSave.informationCompliance.generalInformation.curriculum.document
		const fileNewName = `${supplierToSave.informationCompliance.generalInformation.curriculum.yearCreatedAt}-${supplierToSave.informationCompliance.generalInformation.curriculum.monthCreatedAt}-${supplierToSave.informationCompliance.generalInformation.curriculum.document.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "")}`
		filesToSave.push({ file: fileToSave, fileNewName: fileNewName })
		supplierToSave.informationCompliance.generalInformation.curriculum.checkThis = true
	}
	supplierToSave.informationCompliance.generalInformation.curriculum.uploadedAt = supplierToSave.informationCompliance.generalInformation.curriculum.uploadedAt ? supplierToSave.informationCompliance.generalInformation.curriculum.document && supplierToSave.informationCompliance.generalInformation.curriculum.document.name ? `${month}/${day}/${year}` : supplierToSave.informationCompliance.generalInformation.curriculum.document ? supplierToSave.informationCompliance.generalInformation.curriculum.uploadedAt : "" : supplierToSave.informationCompliance.generalInformation.curriculum.document && `${month}/${day}/${year}`
	supplierToSave.informationCompliance.generalInformation.curriculum.document = supplierToSave.informationCompliance.generalInformation.curriculum.document && (supplierToSave.informationCompliance.generalInformation.curriculum.document.name ? `${supplierToSave.informationCompliance.generalInformation.curriculum.yearCreatedAt}-${supplierToSave.informationCompliance.generalInformation.curriculum.monthCreatedAt}-${supplierToSave.informationCompliance.generalInformation.curriculum.document.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "")}` : supplierToSave.informationCompliance.generalInformation.curriculum.document)

	if (!supplierToSave.informationCompliance.generalInformation.profilePhoto.yearCreatedAt || !supplierToSave.informationCompliance.generalInformation.profilePhoto.monthCreatedAt || !supplierToSave.informationCompliance.generalInformation.profilePhoto.dayCreatedAt) {
		supplierToSave.informationCompliance.generalInformation.profilePhoto.yearCreatedAt = year
		supplierToSave.informationCompliance.generalInformation.profilePhoto.monthCreatedAt = month
		supplierToSave.informationCompliance.generalInformation.profilePhoto.dayCreatedAt = day
	}

	if (supplierToSave.informationCompliance.generalInformation.profilePhoto.document?.name) {
		saveWithFile = true
		const fileToSave = supplierToSave.informationCompliance.generalInformation.profilePhoto.document
		const fileNewName = `${year}-${month}-${supplierToSave.informationCompliance.generalInformation.profilePhoto.document?.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "")}`
		filesToSave.push({ file: fileToSave, fileNewName: fileNewName })
		supplierToSave.informationCompliance.generalInformation.profilePhoto.checkThis = true
	}
	supplierToSave.informationCompliance.generalInformation.profilePhoto.uploadedAt = supplierToSave.informationCompliance.generalInformation.profilePhoto.uploadedAt ? supplierToSave.informationCompliance.generalInformation.profilePhoto.document && supplierToSave.informationCompliance.generalInformation.profilePhoto.document?.name ? `${month}/${day}/${year}` : supplierToSave.informationCompliance.generalInformation.profilePhoto.document ? supplierToSave.informationCompliance.generalInformation.profilePhoto.uploadedAt : "" : supplierToSave.informationCompliance.generalInformation.profilePhoto.document && `${month}/${day}/${year}`
	supplierToSave.informationCompliance.generalInformation.profilePhoto.document = supplierToSave.informationCompliance.generalInformation.profilePhoto.document && (supplierToSave.informationCompliance.generalInformation.profilePhoto.document?.name ? `${year}-${month}-${supplierToSave.informationCompliance.generalInformation.profilePhoto.document?.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "")}` : supplierToSave.informationCompliance.generalInformation.profilePhoto.document)

	supplierToSave?.staffs?.forEach(staff => {
		if (staff.profilePhoto?.document && staff.profilePhoto?.document.name) {
			saveWithFile = true
			const fileToSave = staff.profilePhoto?.document
			const fileNewName = `${year}-${month}-${staff.profilePhoto?.document?.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "")}`
			filesToSave.push({ file: fileToSave, fileNewName: fileNewName })
			staff.profilePhoto.checkThis = true
		}
		if (staff.profilePhoto) {
			staff.profilePhoto.uploadedAt = staff.profilePhoto?.uploadedAt ? staff.profilePhoto?.document && staff.profilePhoto?.document?.name ? `${month}/${day}/${year}` : staff.profilePhoto?.document ? staff.profilePhoto?.uploadedAt : "" : staff.profilePhoto?.document && `${month}/${day}/${year}`
			staff.profilePhoto.document = staff.profilePhoto?.document && (staff.profilePhoto?.document?.name ? `${year}-${month}-${staff.profilePhoto?.document?.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "")}` : staff.profilePhoto?.document)
		}

		staff.payrollReceipts.forEach(receipt => {
			if (receipt.document && receipt.document.name) {
				saveWithFile = true
				const fileToSave2 = receipt.document
				const fileNewName2 = `${receipt.yearCreatedAt}-${receipt.monthCreatedAt}-${receipt.document.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "")}`
				filesToSave.push({ file: fileToSave2, fileNewName: fileNewName2 })
				receipt.checkThis = true
			}
			if (receipt) {
				receipt.document = receipt.document && (receipt.document.name ? `${receipt.yearCreatedAt}-${receipt.monthCreatedAt}-${receipt.document.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "")}` : receipt.document)
			}
		})
	})

	supplierToSave.productsAndServices.products.forEach(product => {
		if (product.drawing.document && product.drawing.document.name) {
			saveWithFile = true
			const fileToSave = product.drawing.document
			const fileNewName = `${product.drawing.yearCreatedAt}-${product.drawing.monthCreatedAt}-${product.drawing.document.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "")}`
			filesToSave.push({ file: fileToSave, fileNewName: fileNewName })
			product.drawing.checkThis = true
		}
		product.drawing.uploadedAt = product.drawing.uploadedAt ? product.drawing.document && product.drawing.document.name ? `${month}/${day}/${year}` : product.drawing.document ? product.drawing.uploadedAt : "" : product.drawing.document && `${month}/${day}/${year}`
		product.drawing.document = product.drawing.document && (product.drawing.document.name ? `${product.drawing.yearCreatedAt}-${product.drawing.monthCreatedAt}-${product.drawing.document.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "")}` : product.drawing.document)

		if (product.picture.document && product.picture.document.name) {
			saveWithFile = true
			const fileToSave = product.picture.document
			const fileNewName = `${product.picture.yearCreatedAt}-${product.picture.monthCreatedAt}-${product.picture.document.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "")}`
			filesToSave.push({ file: fileToSave, fileNewName: fileNewName })
			product.picture.checkThis = true
		}
		product.picture.uploadedAt = product.picture.uploadedAt ? product.picture.document && product.picture.document.name ? `${month}/${day}/${year}` : product.picture.document ? product.picture.uploadedAt : "" : product.picture.document && `${month}/${day}/${year}`
		product.picture.document = product.picture.document && (product.picture.document.name ? `${product.picture.yearCreatedAt}-${product.picture.monthCreatedAt}-${product.picture.document.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "")}` : product.picture.document)
	})

	supplierToSave.qualitySurvey.certifications.forEach(certification => {
		if (!certification.certification.yearCreatedAt || !certification.certification.monthCreatedAt || !certification.certification.dayCreatedAt) {
			certification.certification.yearCreatedAt = year
			certification.certification.monthCreatedAt = month
			certification.certification.dayCreatedAt = day
		}

		if (certification.certification.document && certification.certification.document.name) {
			saveWithFile = true
			const fileToSave = certification.certification.document
			const fileNewName = `${year}-${month}-${certification.certification.document.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "")}`
			filesToSave.push({ file: fileToSave, fileNewName: fileNewName })
			certification.certification.checkThis = true
		}
		certification.certification.document && certification.certification.document.name && formData.append("document", certification.certification.document, `${year}-${month}-${certification.certification.document.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "")}`)
		certification.certification.uploadedAt = certification.certification.uploadedAt ? certification.certification.document && certification.certification.document.name ? `${month}/${day}/${year}` : certification.certification.document ? certification.certification.uploadedAt : "" : certification.certification.document && `${month}/${day}/${year}`
		certification.certification.document = certification.certification.document && (certification.certification.document.name ? `${year}-${month}-${certification.certification.document.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "")}` : certification.certification.document)
	})

	saveWithFile && filesToSave.forEach(doc => {
		formData.append("document", doc.file, doc.fileNewName)
	})
	formData.append("saveWithFile", saveWithFile)
	formData.append("supplier", JSON.stringify(supplierToSave))

	const { data } = await axios.put(URI_SUPPLIER + dataID, formData)
	return { ...data, saveWithFile }
}

export const updateReadyForReview = async ({ id, clientID, username, dataID, rol }) => {
	const { data } = await axios.patch(URI_SUPPLIER_CLIENT_STATUS + id, {
		clientID,
		newStatus: "Ready for review",
		username,
		dataID,
		rol,
	})
	return data.supplier
}
